import { logger, safeError } from '../utils/logger';
import api from '../api/api';

export class EmpresaGestoraService {
  
  // Servicio para cargar empresas gestoras por tipo de usuario
  static async findByTipoUsuario(idUsuario: number): Promise<any> {
    try {
      const response = await api.get(`/empresasGestoras/findByTipoUsuario?idUsuario=${idUsuario}`);
      return response.data;
    } catch (error: any) {
      logger.error('Error al cargar empresas gestoras por tipo usuario:', safeError(error));
      throw error;
    }
  }

  // Servicio para cargar empresas gestoras por contratista (si lo necesitas)
  static async findByContratista(idContratista: number): Promise<any> {
    try {
      const response = await api.get(`/empresasGestoras/find?idContratista=${idContratista}`);
      return response.data;
    } catch (error: any) {
      logger.error('Error al cargar empresas gestoras por contratista:', safeError(error));
      throw error;
    }
  }

  // Método para obtener todas las empresas gestoras (si necesitas uno general)
  static async getAll(): Promise<any> {
    try {
      const response = await api.get('/empresasGestoras');
      return response.data;
    } catch (error: any) {
      logger.error('Error al cargar todas las empresas gestoras:', safeError(error));
      throw error;
    }
  }
}